import React, {useEffect, useState} from 'react';
import $ from 'jquery';
const LoginForm = ({show, onAuth, onClose}) => {
  const [ login, setLogin ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ errors, setErrors ] = useState(null);
  const [ isAuth, setIsAuth ] = useState(false);
  const [isShowForm, setIsShowForm] = useState(show);

  const handleClose = () => {
    setIsShowForm(false);
    onClose();
  }

  const handleLogin = () => {
    if (login && password) {
      $.ajax({
        url: 'https://cabinet.geograftour.com/api/login/',
        type: 'OPTIONS',
        dataType: 'json',
        crossDomain: true,
        xhrFields: {
            withCredentials: true
        },
        headers: {
            'lgn': login,
            'pwd': password,
        },
        error: function (jqxhr) {
            console.log('Failed to load resource', jqxhr);
        },
        success: function( data ) {
            if (data.errors !== undefined) {
                setErrors(data.errors);
            } else {
                setIsAuth(true);
                handleClose();
                onAuth();
            }
        },
      });
    }
  }
  // useEffect(() => {
  //   setIsShowForm(show);
  // }, [show]);
  return <>
    { isShowForm && <div className="gt-popup__bg" onClick={() => handleClose() }>
    <div className="gt-popup-custom__window" >
      <div id="logbyform" onClick={(e) => e.stopPropagation() }>
        <span className="formBlock">
          <div className="formHead">
            <span className="titleForm">Войдите в акаунт,<br/></span>
            <span>или </span>
            <a href="https://cabinet.geograftour.com/" target="_blank" rel="nofollow noopener"
            className="doItLink">зарегистрируйтесь</a>
          </div>
          <div className="logregForm">
            <div className="popup-form">
              <div className="form-field__item">
                <p>логин:</p>
                <input type="email" placeholder="E-mail" required="required" value={login} onInput={(e) => setLogin(e.target.value)} />
              </div>
              <div className="form-field__item">
                <p>пароль</p>
                <input type="password" placeholder="Пароль" required="required" value={password}  onInput={(e) => setPassword(e.target.value)} />
              </div>
              <div className="form-field__item">
                <a href="#" rel="nofollow noopener" className="login__button" onClick={handleLogin}>Войти</a>
              </div>
              <div>
                <a href="https://cabinet.geograftour.com/" target="_blank" rel="nofollow noopener" className="formLink">Забыли пароль?</a>
              </div>
            </div>
            <div className="errorBlock">
              { errors && <p>{errors}</p> }
            </div>
          </div>
        </span>
      </div>
      <i className="gt-popup__close fa fa-close" alt="close"></i>
    </div>
  </div> }
  </>
}
export default LoginForm;